// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"8a599789","963":"d6f1900f"}[chunkId] + ".chunk.js";
};